export default __webpack_public_path__ + "static/media/photo--sm--chris-6.3b9f8fc7.jpg";